import { GamificationTier, getTierByPods } from "../context/NespressoContext";

export interface LeaderboardEntry {
  rank: number;
  name: string;
  podsReturned: number;
  tier: GamificationTier;
}

/**
 * Sample leaderboard data for Lincoln Road Boutique, Miami Beach
 *
 * Per spec requirements:
 * - Top 3: Grand Cru tier (1,500+ pods)
 * - Positions 4-10: Intenso tier (750-1,499 pods)
 * - Mixed gender/ethnicity, predominantly female
 * - Given Miami location, many Hispanic names
 */
export const LINCOLN_ROAD_LEADERBOARD: LeaderboardEntry[] = [
  // Top 3 - Grand Cru tier (1,500+)
  { rank: 1, name: "Isabella M.", podsReturned: 2847 },
  { rank: 2, name: "Sofia R.", podsReturned: 2234 },
  { rank: 3, name: "Carmen L.", podsReturned: 1856 },
  // Positions 4-10 - Intenso tier (750-1,499)
  { rank: 4, name: "Miguel A.", podsReturned: 1432 },
  { rank: 5, name: "Elena V.", podsReturned: 1287 },
  { rank: 6, name: "Lucia K.", podsReturned: 1145 },
  { rank: 7, name: "Ana P.", podsReturned: 1023 },
  { rank: 8, name: "Gabriela W.", podsReturned: 945 },
  { rank: 9, name: "Maria G.", podsReturned: 867 },
  { rank: 10, name: "Rosa H.", podsReturned: 798 },
].map((entry) => ({
  ...entry,
  tier: getTierByPods(entry.podsReturned),
}));

export const DEFAULT_BOUTIQUE_NAME = "Lincoln Road, Miami Beach";
